import { appV2EventPrefix } from "@src/appV2/lib/analytics/events";

const prefix = `${appV2EventPrefix} No Show Warning`;

export const NO_SHOW_WARNING_ANALYTICS_EVENTS = {
  /** Fired when the warning step is displayed to the user */
  VIEWED: `${prefix} Viewed`,
  /** Fired when the user clicks "Confirm No Show" on the warning step */
  CONFIRMED: `${prefix} Confirmed`,
  /**
   * Fired when the user dismisses the warning without proceeding.
   * Include `action: "back" | "close"` in properties to distinguish dismissal method.
   */
  DISMISSED: `${prefix} Dismissed`,
} as const;
